import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect, useRef } from "react";

import Image from "../fragments/Image";
import SpecialText from '../fragments/SpecialText';

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default function WhatWeOffer({ block }) {
    
    const swiperRef = useRef(null);
    const mediaRevealRef = useReveal({ once: true });

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--what-we-offer`}>
            <div className={`l-grid`}>
                <div className={'l-grid__col c-transition-in'} ref={mediaRevealRef}>
                    <div className="c-what-we-offer">
                        <h3 className="c-what-we-offer__heading c-heading">
                            <SpecialText text={block.heading || 'What We Offer'} />
                        </h3>
                        <div className="c-what-we-offer__image">
                            <div className="c-what-we-offer__image__inner">
                                {block.top_left_img_src && (
                                    <div className="c-what-we-offer__image__top-left c-parallax" data-speed="0.0125">
                                        <Image 
                                            src={block.top_left_img_src || []} 
                                            alt={''} 
                                        />
                                    </div>
                                )}
                                {block.top_right_img_src && (
                                    <div className="c-what-we-offer__image__top-right">
                                        <Image 
                                            src={block.top_right_img_src || []} 
                                            alt={''} 
                                        />
                                    </div>
                                )}
                                {block.bottom_left_img_src && (
                                    <div className="c-what-we-offer__image__bottom-left">
                                        <Image 
                                            src={block.bottom_left_img_src || []} 
                                            alt={''} 
                                        />
                                    </div>
                                )}
                                {block.bottom_right_img_src && (
                                    <div className="c-what-we-offer__image__bottom-right c-parallax" data-speed="0.025">
                                        <Image 
                                            src={block.bottom_right_img_src || []} 
                                            alt={''} 
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        <Swiper
                            modules={[Pagination, EffectFade]}
                            pagination={{ clickable: true }}
                            effect="fade"
                            fadeEffect={{ crossFade: true }}
                            slidesPerView={1}
                            spaceBetween={0}
                            grabCursor={true}
                            onSwiper={(s) => (swiperRef.current = s)}
                            className="scope-what-we-offer-swiper"
                        >
                            {block.slides.map((slide, index) => (
                                <SwiperSlide key={index}>
                                    <div className="c-what-we-offer__slide">
                                        <div className="c-what-we-offer__slide__content">
                                            <h4 className="c-what-we-offer__slide__content__heading c-paragraph c-paragraph--space c-paragraph--medium c-paragraph--accent" dangerouslySetInnerHTML={{__html:slide.heading}} />
                                            <div className="scope-text scope-text--medium c-what-we-offer__slide__content__text" dangerouslySetInnerHTML={{__html:slide.text}} />
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    )
}